// extracted by mini-css-extract-plugin
module.exports = {"item":"MyDownloads_item__2XQC3","item-desc":"MyDownloads_item-desc__3JsOr","opened":"MyDownloads_opened__6-cLB"};